<template>
  <div class="spin-wheel-dialog">
    <v-form ref="form" v-model="isFormValid">
      <div class="mb-4">
        <va-tinymce-input
          class="w-full"
          :current-content="formData.message"
          :editor-height="120"
          live-chat-message-preset
          title="Message"
          :forced-root-block-attrs="{ class: 'live-chat-message' }"
          auto-resize
          @update="content => updateMessageContent(content)" />
      </div>

      <v-row class="spin-wheel-dialog-rows">
        <v-col cols="12">
          <v-text-field type="text" v-model="formData.buttonText" label="Button Text"></v-text-field>
        </v-col>
      </v-row>

      <v-text-field type="text" v-model="formData.buttonLink" label="Button Link/Redirect"></v-text-field>

      <v-checkbox :label="'Automatically redirect'" v-model="formData.redirectOnClick" color="primary" class="mb-4">
      </v-checkbox>

      <v-alert v-if="errorMessage" type="error" class="mt-4" dismissible @input="errorMessage = ''">
        {{ errorMessage }}
      </v-alert>
    </v-form>
  </div>
</template>

<script>
  import { SPIN_WHEEL_EVENT_TYPES } from "@/constant";
  import VaTinymceInput from "@/components/custom/VaTinymceInput";

  export default {
    components: {
      VaTinymceInput,
    },
    data() {
      return {
        isFormValid: false,
        formData: {
          buttonText: "",
          buttonLink: "",
          message: "",
          redirectOnClick: false,
        },
        errorMessage: "",
      };
    },
    watch: {
      isFormValid: {
        handler() {
          this.sendError();
        },
      },
      formData: {
        handler() {
          this.validateAndUpdate();
        },
        deep: true,
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();
    },
    methods: {
      updateMessageContent(content) {
        this.formData.message = content;
      },
      async validateAndUpdate() {
        if (this.$refs.form) {
          await this.$refs.form.validate();
          if (this.isFormValid) {
            this.updateValue();
            this.errorMessage = "";
          }
        }
      },
      sendError() {
        window.parent.postMessage(
          {
            mceAction: SPIN_WHEEL_EVENT_TYPES.VALIDATION,
            data: {
              isValid: this.isFormValid,
            },
          },
          origin,
        );
      },
      updateValue() {
        window.parent.postMessage(
          {
            mceAction: SPIN_WHEEL_EVENT_TYPES.UPDATE_SPIN_WHEEL_DATA,
            data: this.formData,
          },
          origin,
        );
      },

      setupReceiveDataListener() {
        window.onmessage = async message => {
          if (message.data.type === SPIN_WHEEL_EVENT_TYPES.NEED_VALIDATION) {
            await this.$refs.form.validate();
          }
          if (message.data.type === SPIN_WHEEL_EVENT_TYPES.SEND_DATA) {
            const { data } = message.data;
            //Set default values if user exits toast window without saving (prevents JSON error)
            if (data === "undefined") {
              this.updateValue();
            } else {
              this.formData = {
                buttonText: data.buttonText || "",
                buttonLink: data.buttonLink || "",
                message: data.message || "",
                redirectOnClick: data.redirectOnClick !== undefined ? data.redirectOnClick : false,
              };
            }
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: SPIN_WHEEL_EVENT_TYPES.REQUEST_DATA,
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .spin-wheel-dialog {
    margin-bottom: 30px;
    padding: 30px 12px 0px;
  }

  .spin-wheel-dialog-rows {
    margin-bottom: 15px;
  }
</style>
